import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

function EnderecoGrupoMap({
    center,
    zoom,
    address,
    onClick,
    onGeocodeSuccess,
    children,
}) {
    const [map, setMap] = useState();
    const [geocoder, setGeocoder] = useState();
    const ref = useRef();

    useEffect(() => {
        if (ref.current && !map) {
            setMap(
                new window.google.maps.Map(ref.current, {
                    center,
                    zoom,
                    streetViewControl: false,
                })
            );
            setGeocoder(new window.google.maps.Geocoder());
        }
    }, [ref, map, center, zoom]);

    useEffect(() => {
        if (map) {
            map.setCenter(center);
        }
    }, [map, center]);

    useEffect(() => {
        if (address) {
            geocoder.geocode({ address }, function callback(results, status) {
                if (status === 'OK') {
                    onGeocodeSuccess(results[0].geometry.location.toJSON());
                } else {
                    // eslint-disable-next-line no-console
                    console.log(
                        'Não foi possível obter as coordenadas do endereço.',
                        status
                    );
                }
            });
        }
    }, [address]);

    useEffect(() => {
        if (map) {
            window.google.maps.event.clearListeners(map, 'click');

            if (onClick) {
                map.addListener('click', onClick);
            }
        }
    }, [map, onClick]);

    return (
        <>
            <div ref={ref} id="map" style={{ height: 400 }} />
            {React.Children.map(children, child => {
                if (React.isValidElement(child)) {
                    return React.cloneElement(child, { map });
                }

                return null;
            })}
        </>
    );
}

EnderecoGrupoMap.propTypes = {
    center: PropTypes.shape({
        lat: PropTypes.number.isRequired,
        lng: PropTypes.number.isRequired,
    }).isRequired,
    zoom: PropTypes.number.isRequired,
    address: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    onGeocodeSuccess: PropTypes.func.isRequired,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]).isRequired,
};

EnderecoGrupoMap.defaultProps = {
    address: '',
};

export default EnderecoGrupoMap;
